// @ts-nocheck
/**
 * Chart Mock Data - Comprehensive data for all chart types
 */

import { generateTimeSeriesData } from './helpers';

// Line Chart Data - 365 days of time-series data
export const mockLineChartData = generateTimeSeriesData(365, 1000, 0.15, 'up', true);

// Multi-series line chart data
export const mockMultiSeriesLineData = (() => {
  const days = 90;
  const users = generateTimeSeriesData(days, 500, 0.1, 'up', false);
  const sessions = generateTimeSeriesData(days, 1200, 0.12, 'up', true);
  const pageviews = generateTimeSeriesData(days, 5000, 0.15, 'up', true);

  return users.map((item, idx) => ({
    date: item.date,
    users: item.value,
    sessions: sessions[idx].value,
    pageviews: pageviews[idx].value,
  }));
})();

// Bar Chart Data - 15+ categories
export const mockBarChartData = [
  { category: 'Ministry of Education', tasks: 145, completed: 112, pending: 33 },
  { category: 'Ministry of Health', tasks: 89, completed: 67, pending: 22 },
  { category: 'Ministry of Finance', tasks: 203, completed: 198, pending: 5 },
  { category: 'Ministry of Defense', tasks: 56, completed: 45, pending: 11 },
  { category: 'Ministry of Agriculture', tasks: 78, completed: 62, pending: 16 },
  { category: 'Ministry of Transport', tasks: 134, completed: 101, pending: 33 },
  { category: 'Ministry of Energy', tasks: 92, completed: 88, pending: 4 },
  { category: 'Ministry of Trade', tasks: 67, completed: 54, pending: 13 },
  { category: 'Ministry of Justice', tasks: 45, completed: 42, pending: 3 },
  { category: 'Ministry of Interior', tasks: 123, completed: 97, pending: 26 },
  { category: 'Ministry of Foreign Affairs', tasks: 81, completed: 73, pending: 8 },
  { category: 'Ministry of Culture', tasks: 34, completed: 29, pending: 5 },
  { category: 'Ministry of Sports', tasks: 28, completed: 25, pending: 3 },
  { category: 'Ministry of Environment', tasks: 72, completed: 65, pending: 7 },
  { category: 'Ministry of Technology', tasks: 156, completed: 134, pending: 22 },
];

// Pie/Donut Chart Data - 10+ segments
export const mockPieChartData = [
  { name: 'Admin Users', value: 45, color: '#228be6' },
  { name: 'Regular Users', value: 234, color: '#40c057' },
  { name: 'Guest Users', value: 89, color: '#fab005' },
  { name: 'Premium Users', value: 67, color: '#7950f2' },
  { name: 'Suspended Users', value: 12, color: '#fa5252' },
  { name: 'Pending Approval', value: 34, color: '#fd7e14' },
  { name: 'Inactive', value: 56, color: '#868e96' },
  { name: 'Trial Users', value: 23, color: '#15aabf' },
  { name: 'Enterprise', value: 18, color: '#e64980' },
  { name: 'Student', value: 78, color: '#51cf66' },
];

// Area Chart Data - Revenue streams over time
export const mockAreaChartData = (() => {
  const days = 180;
  const subscriptions = generateTimeSeriesData(days, 15000, 0.08, 'up', false);
  const oneTime = generateTimeSeriesData(days, 8000, 0.15, 'flat', true);
  const services = generateTimeSeriesData(days, 5000, 0.12, 'up', false);

  return subscriptions.map((item, idx) => ({
    date: item.date,
    subscriptions: item.value,
    oneTimePurchases: oneTime[idx].value,
    services: services[idx].value,
  }));
})();

// Revenue by category for stacked bar chart
export const mockRevenueByCategory = [
  { month: 'Jan', products: 12400, services: 8300, subscriptions: 15600 },
  { month: 'Feb', products: 13200, services: 9100, subscriptions: 16800 },
  { month: 'Mar', products: 14800, services: 9800, subscriptions: 18200 },
  { month: 'Apr', products: 13900, services: 10200, subscriptions: 17900 },
  { month: 'May', products: 15600, services: 11000, subscriptions: 19500 },
  { month: 'Jun', products: 16200, services: 11500, subscriptions: 20100 },
  { month: 'Jul', products: 17100, services: 12300, subscriptions: 21800 },
  { month: 'Aug', products: 16800, services: 12100, subscriptions: 20900 },
  { month: 'Sep', products: 18200, services: 13400, subscriptions: 22600 },
  { month: 'Oct', products: 19100, services: 14200, subscriptions: 23800 },
  { month: 'Nov', products: 20300, services: 15100, subscriptions: 25200 },
  { month: 'Dec', products: 22400, services: 16800, subscriptions: 27600 },
];

// User growth over time (last 2 years)
export const mockUserGrowthData = generateTimeSeriesData(730, 5000, 0.05, 'up', false);

// Task completion trends
export const mockTaskCompletionData = (() => {
  const weeks = 52;
  const data = [];
  const now = new Date();

  for (let i = weeks - 1; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i * 7);

    data.push({
      week: `Week ${weeks - i}`,
      date: date.toISOString().split('T')[0],
      created: Math.floor(30 + Math.random() * 20),
      completed: Math.floor(25 + Math.random() * 15),
      overdue: Math.floor(Math.random() * 5),
    });
  }

  return data;
})();
